import { Component, Input } from '@angular/core';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';
import { ActivatedRoute } from '@angular/router';
import { LookupService } from 'src/app/services/lookup.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { VerificationModel } from 'src/app/models/verification';

@Component({
    selector: 'app-verification',
    templateUrl: 'verification.component.html',
    styleUrls: ['verification.component.css'],
    standalone: false
})
export class VerificationComponent {
    msg: string;
    isVisible: boolean = false;
    constructor(
        private confirmDialogService: ConfirmDialogService,
        private activatedRoute: ActivatedRoute,
        private lookupService: LookupService,
        private spinner: NgxSpinnerService
    ) { }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            let model: VerificationModel = new VerificationModel();
            // model.BidderId = params.bidderId;
            // model.OTP = params.code;
            // model.Type = 'Email';
            // model.Email = params.email;
            // model.FirstName = params.fName;
            // model.LastName = params.lName;
            // model.UserName = params.userName;
            let token = params.token;
            this.getVerification(token);
        });
    }
    getVerification(token) {
        this.spinner.show();
        this.lookupService.getVerification(token).subscribe(response => {
            this.spinner.hide();
            if (response.id > 0) {
                this.isVisible = true;
                this.msg = response.result;
            } else {
                this.isVisible = true;
                this.msg = response.result;
            }
        }, error => {
            this.isVisible = false;
            this.msg = "Verification failed due to some reason.";
            this.spinner.hide();
        });
    }
}  